import React, { useEffect } from 'react';
import { RouteComponentProps } from '@reach/router';
import { SidePanelNavButton } from '../../components/side-panel-nav-button';
import { View } from '../../components/view';
import { useStateValue } from '../../components/state';

export const Reuse: React.FC<RouteComponentProps> = ({ children, location }) => {
  const [, dispatch] = useStateValue();

  // Filter map pins to all
  useEffect(() => {
    dispatch({ type: 'setActiveMarkerSet', payload: { activeMarkerSet: 'alternate' } });
    dispatch({ type: 'setSidePanelFull', payload: { sidePanelFull: false } });
    dispatch({ type: 'setActiveYear', payload: { activeYear: 2019 } });
  }, [dispatch]);

  return (
    <View>
      {location && location.pathname !== '/reuse' && (
        <SidePanelNavButton href="/reuse">Where does your water go to?</SidePanelNavButton>
      )}
      {children}
    </View>
  );
};
